import { Injectable } from '@angular/core';
import {AuthHttp} from '../../../user/services/auth/http/auth-http.service';
import {environment} from '../../../../../environments/environment';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';
import {Pagination} from '../../../utilities/interfaces/Pagination';
import {Airport} from '../../interfaces/Airport';
import {ObjectMapService} from '../../../utilities/services/object-map/object-map.service';
import {PaginationAbstractService} from '../../../utilities/services/pagination-abstract/pagination-abstract.service';
import {AirportParams} from '../../interfaces/AirportParams';

@Injectable()
export class AirportService extends PaginationAbstractService<Airport, AirportParams> {

    private route = 'airport';

    constructor(private http: AuthHttp, private objMapService: ObjectMapService) {
      super(objMapService, 'airportParams');
    }

    public getAirports(params?: AirportParams): Promise<Pagination<Airport>> {
      return this.getPagination(params).toPromise();
    }

    protected prefetch() {
      return this.http
        .get(`${environment.baseUrl}${this.route}`, {params: this._params})
        .map((res) => res.json());
    }

    public getAllAirports(): Promise<Pagination<Airport>> {
      return this.http
        .get(`${environment.baseUrl}${this.route}?limit=9999&page=1`)
        .map((res) => res.json()).toPromise();
    }

  public getAllAirportsForCerf() {
    return this.http
      .get(`${environment.baseUrl}${this.route}/all`)
      .map((res) => res.json()).toPromise();
  }

    public getAirport(id) {
        return this.http.get(`${environment.baseUrl}${this.route}/${id}`).map((res) => res.json()).toPromise();
    }

    public update(airport: Airport) {
        this.clearCache();
        return this.http.put(`${environment.baseUrl}${this.route}/${airport.id}`, airport).toPromise();
    }


    public create(airport) {
        this.clearCache();
        return this.http.post(`${environment.baseUrl}${this.route}`, airport).map((res) => res.json()).toPromise();
    }


    public delete(id) {
        this.clearCache();
        return this.http.delete(`${environment.baseUrl}${this.route}/${id}`).map((res) => res.json()).toPromise();
    }

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/airport/services/airport/airport.service.ts